import { render } from "./CustomerMenu.vue?vue&type=template&id=4309070c&scoped=true"
import script from "./CustomerMenu.vue?vue&type=script&lang=js"
export * from "./CustomerMenu.vue?vue&type=script&lang=js"

import "./CustomerMenu.vue?vue&type=style&index=0&id=4309070c&scoped=true&lang=css"

import exportComponent from "/Users/tizetimoyosore/Developer/Expresswifi_os/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4309070c"]])

export default __exports__